import * as React from 'react';
export const IcDataLoan = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.71 7.71L9 6.41V12a1 1 0 102 0V4a1 1 0 00-.62-.92 1 1 0 00-1.09.21l-3 3a1.004 1.004 0 001.42 1.42zm5.91 5.21A.84.84 0 0014 13a1 1 0 00.71-.29l3-3A1.005 1.005 0 0017 7.996a1.004 1.004 0 00-.71.294L15 9.59V4a1 1 0 00-2 0v8a1 1 0 00.62.92zm7.07 3.14a1 1 0 00-1.41 0l-2.17 2.28a1.999 1.999 0 01-1.45.62H12a1 1 0 010-2h1.66a1 1 0 000-2H8a2 2 0 00-2 2H4a1 1 0 00-1 1v2a1 1 0 001 1h11.66a4 4 0 002.89-1.24l2.17-2.28a1 1 0 00-.03-1.38z'
      fill='currentColor'
    />
  </svg>
);
